import dom, { Fragment } from "../../dist/jsx-render/dom";
import JSXComponent from "../../dist/jsx-render/JSXComponent";

export type DropDownItemComponentProps = {
    item: any;
    displayProperty: string;
    valueProperty: string;
    childrenProperty?: string;
    onItemClick: (item: any) => void;
    expandAll: boolean;
    flatItems?: DropDownItemComponent[];
    allowParentSelect?: boolean;
}

/**
 * Component for a autocomplete drop down.
 */
export class DropDownItemComponent extends JSXComponent {
    props: DropDownItemComponentProps;

    constructor(props: DropDownItemComponentProps) {
        super(props);
    }
    
    expandIcon: HTMLElement =
        <i className="cc-expand fas"></i>;

    textElement: HTMLElement = <div className="cc-text">{this.props.item[this.props.displayProperty]}</div>;

    
    element: HTMLElement =
        <a className="dropdown-item cc-item" href="#" title={this.props.item.tooltip ? this.props.item.tooltip : ''} data-categoryId={this.props.item.categoryId ? this.props.item.categoryId : ''} data-parentCategoryId={this.props.item.parentCategoryId ? this.props.item.parentCategoryId : ''} data-parentCategoryName={this.props.item.parentCategoryName ? this.props.item.parentCategoryName : ''}>
            {this.expandIcon}
            {this.textElement}
        </a>

    childFrame: HTMLElement;

    createChildFrame(children: any[]): HTMLElement {
        return (
            <div className={this.props.expandAll ? "cc-childs" : "cc-childs d-none"}>
                {children.map((c: any) => {
                    let dropdownItemProps = {
                        item: c,
                        displayProperty: this.props.displayProperty,
                        valueProperty: this.props.valueProperty,
                        childrenProperty: this.props.childrenProperty,
                        onItemClick: this.props.onItemClick,
                        expandAll: this.props.expandAll,
                        flatItems: this.props.flatItems,
                        allowParentSelect: this.props.allowParentSelect
                    }
                    let dropdownItem = new DropDownItemComponent(dropdownItemProps);

                    if (this.props.flatItems) {
                        this.props.flatItems.push(dropdownItem);
                    }

                    return dropdownItem.render();
                })}
            </div>
        );
    }

    createWithChildren() {
        return (
            <Fragment>
                {this.element}
                {this.childFrame}
            </Fragment>
        );
    }

    highlight = () => {
        this.element.classList.add("selected");
    }

    render(): HTMLElement {

        let children = null;
        if (this.props.childrenProperty) {
            children = this.props.item[this.props.childrenProperty];
        }

        if (!this.props.item[this.props.displayProperty]) {
            this.props.item[this.props.displayProperty] = "";
        }

        if (children && children.length > 0) {
            this.childFrame = this.createChildFrame(children);
            let result = this.createWithChildren();
            if (this.props.allowParentSelect) {
                this.expandIcon.addEventListener("click", this.onExpandCollapse);
                this.textElement.addEventListener("click", this.onSelect);
            } else {
                this.element.addEventListener("click", this.onExpandCollapse);
            }
            if (this.props.expandAll) {
                this.expandIcon.classList.add("fa-caret-down");
            }
            else {
                this.expandIcon.classList.add("fa-caret-right");
            }
            return result;
        }
        else {
            let result = this.element;
            if (this.props.item["isEmpty"] === true) {
                this.element.addEventListener("click", this.onSelect);
            } else {
                this.textElement.addEventListener("click", this.onSelect);
            }
            return result;
        }
    }

    onExpandCollapse = (event: Event) => {
        event.stopPropagation();
        event.cancelBubble = false;

        if (this.childFrame.classList.contains("d-none")) {
            this.childFrame.classList.remove("d-none");
            this.expandIcon.classList.remove("fa-caret-right");
            this.expandIcon.classList.add("fa-caret-down");
        }
        else {
            this.childFrame.classList.add("d-none");
            this.expandIcon.classList.add("fa-caret-right");
            this.expandIcon.classList.remove("fa-caret-down");
        }
    }

    onSelect = () => {
        this.props.onItemClick(this.props.item);
    }
}
